<template>
  <div
    v-if="$store.getters.marchand && $store.getters.marchand._env === 'live'"
    class="row"
    style="padding: 5px"
  >
    <div class="col-12 mb-4">
      <div class="pb-4">
        <v-btn
          @click="$router.go(-1)"
          outlined
          style="border: none; background: #fff"
          title="Retourner"
        >
          <v-icon>mdi mdi-arrow-left</v-icon> Menu
        </v-btn>
      </div>
      <div class="mt-3 mb-0 pb-0">
        <v-alert type="info">
          Définissez les tranches de paiements des frais scolaires de vos
          élèves/étudiants. Chaque élève/étudiant pourra respecter les
          obligations avec autant de paiements que possible pour chaque tranche.
        </v-alert>
      </div>
      <v-card elevation="0" class="mt-4">
        <v-data-table
          :headers="headers"
          :items="classes"
          :search="search"
          sort-by="label"
          class="elevation-1"
          :loading="loadings.classes"
          loading-text="Chargement en cours..."
        >
          <template v-slot:item.actions="{ item }">
            <div style="text-align: right">
              <v-menu key="text" rounded="b-xl">
                <template v-slot:activator="{ attrs, on }">
                  <v-icon class="black--text" v-bind="attrs" v-on="on"
                    >mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(action_item, index) in actions_items"
                    :key="index"
                    link
                    @click="editItemAction(item, index)"
                  >
                    <v-list-item-icon>
                      <v-icon color="#29B3A6">{{ action_item.avatar }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="action_item.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>

          <template v-slot:top>
            <v-row style="background: #f8f8f8">
              <v-col cols="12" sm="4">
                <v-text-field
                  solo
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row style="background: #f8f8f8">
              <v-toolbar flat>
                <v-toolbar-title
                  >Tranches de l'école {{ school?._name }}
                </v-toolbar-title>
                <v-spacer />
                <v-dialog v-model="dialogCustomer" max-width="800px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="secondary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="instalments = JSON.parse(JSON.stringify(classes))"
                    >
                      Modifier
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-text class="mt-5">
                      <v-form ref="clientForm" v-model="clientFormIsValid">
                        <v-card class="pt-0 pb-0">
                          <v-card-text class="pb-0">
                            <v-row
                              class="d-flex justify-content-between align-items-center"
                            >
                              <h5 class="col-12">
                                Générer des tranches par défaut pour la
                                configuration des paiements.
                              </h5>
                              <div class="col-12">
                                <v-alert type="warning" elevation="0">
                                  La somme des pourcentages des tranches doit
                                  etre egale a 100...
                                </v-alert>
                              </div>

                              <v-col cols="12" sm="12" md="6" class="pb-0 mb-0">
                                <label> Nommez la tranche</label>
                                <v-text-field
                                  solo
                                  label="nom de le tranche"
                                  v-model="currentInstalment._name"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="12" md="6" class="pb-0 mb-0">
                                <label>
                                  Pourcentage par rapport au total des frais
                                  {{ currentInstalment._percentage }}</label
                                >
                                <v-slider
                                  v-model="currentInstalment._percentage"
                                  color="black"
                                  min="1"
                                  :max="100 - getTotalPercentage()"
                                  step="1"
                                  thumb-label
                                ></v-slider>
                              </v-col>
                              <v-col cols="12" sm="12" md="6" class="pb-0 mb-0">
                                <label
                                  >Choisir le dernier délai de paiement</label
                                >
                                <div>
                                  <v-menu
                                    v-model="pickdateprogram"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        solo
                                        v-model="currentInstalment._deadline"
                                        label="Choisir le dernier délai de paiement"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="currentInstalment._deadline"
                                      @input="pickdateprogram = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </div>
                              </v-col>
                            </v-row>

                            <v-row
                              cols="12"
                              sm="3"
                              md="3"
                              class="d-flex justify-content-end"
                            >
                              <v-btn
                                :disabled="
                                  currentInstalment._name === '' ||
                                  currentInstalment._percentage === 0 ||
                                  currentInstalment._deadline === ''
                                "
                                color="secondary"
                                @click="addInstalment"
                              >
                                + ajouter</v-btn
                              >
                            </v-row>
                          </v-card-text>
                        </v-card>
                        <v-container>
                          <v-row v-if="instalments.length > 0">
                            <v-data-table
                              style="width: 100%"
                              :items="instalments"
                              :headers="intalment_headers"
                              :hide-default-footer="true"
                            >
                              <template v-slot:item.actions="{ item }">
                                <v-btn
                                  text
                                  @click="
                                    instalments.splice(
                                      instalments.indexOf(item),
                                      1
                                    )
                                  "
                                >
                                  <v-icon color="red"> mdi-delete </v-icon>
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>
                    <v-row
                      class="d-flex justify-content-center"
                      v-if="
                        instalments.reduce(
                          (acc, i) => acc + +i._percentage,
                          0
                        ) != 100
                      "
                    >
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="dark" @click="dialogCustomer = false">
                        annuler
                      </v-btn>
                      <v-btn
                        :disabled="
                          instalments.reduce(
                            (acc, i) => acc + +i._percentage,
                            0
                          ) != 100
                        "
                        color="primary darken-1"
                        @click="saveInstalments"
                        :loading="loadings.instalments_saving"
                      >
                        Enregistrer
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </v-row>
          </template>
          <template v-slot:no-data>
            <span>{{ $t("fees.notFound") }}</span>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import GoToParams from "../administrators/globalComponents/GoToParams";
import { client } from "../../store/services/client";
import { fontAwesomePicker } from "font-awesome-picker";
import Swal from "sweetalert2";

export default {
  components: {
    GoToParams,
    "font-awesome-picker": fontAwesomePicker,
  },
  label: "Instalments",
  data() {
    return {
      type_import: "client",
      sheet: [],
      sheetrules: [
        (value) =>
          !value ||
          value.size < 10000000 ||
          "Avatar size should be less than 10 MB!",
      ],
      page: 0,
      total_pages: 0,
      classestep: 1,
      transaction_name: "",
      currentProduct: null,
      currentQuantity: 1,
      editingCategory: false,
      pickdateprogram: false,
      editingCustomer: false,
      categoryClienFormIsValid: false,
      clientFormIsValid: false,
      selected_client_transaction: [],
      selected_category_client: [],
      transactionInProgress: false,
      requiredRules: [(v) => !!v || "Ce champ est recquis"],
      loadings: {
        classes: false,
        categories: false,
        categoriySaving: false,
        instalments_saving: false,
      },
      whatsapp: "",
      tel: "",
      notifier_whatsapp: "",
      notifier_tel: "",
      dialogTransaction: false,
      produits: [],
      classes: undefined,
      school: undefined,
      all_classes: undefined,
      forCategoryClient: false,
      products: [],
      transaction_produits: [],
      client_transaction: null,
      status_transaction: false,
      dialogDeleteCategory: false,
      dialogDelete: false,
      country_key: "",
      currentInstalment: {
        _name: "",
        _percentage: "",
        _deadline: "",
      },
      lazy: false,
      errors: {},
      search: "",
      dialogCategory: false,
      dialogCustomer: false,
      id: undefined,
      customers_tabs: "",
      settingToSave: {
        _percentage: "",
        _deadline: "",
      },
      headers: [
        { text: "Intitule", value: "_name" },
        { text: "Pourcentage", value: "_percentage" },
        { text: "Date limite", value: "_deadline" },
        // {text: '', value: 'actions'},
      ],
      intalment_headers: [
        { text: "Intitule", value: "_name" },
        { text: "Pourcentage", value: "_percentage" },
        { text: "Date limite", value: "_deadline" },
        { text: "", value: "actions" },
      ],
      transaction_products: [],
      editedIndex: -1,
      editedItem: {},
      user_role: "",
      actions_items: [
        { title: "Modifier", avatar: "mdi-pencil" },
        { title: "Supprimer", avatar: "mdi-delete" },
        { title: "Gérer", avatar: "mdi-eye" },
      ],
      instalments: [],
      categories_actions_items: [
        { title: "Modifier", avatar: "mdi-pencil" },
        { title: "Supprimer", avatar: "mdi-delete" },
      ],
      categories: [],
      category: {
        _name: "",
        _description: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.initialize();
  },
  methods: {
    editItemAction(item, index) {
      switch (index) {
        case 0:
          this.toggleEditSchool(item);
          break;
        case 1:
          this.toggleDeleteFee(item);
          break;
        case 2:
          this.$router.push({
            name: "intramScholar.manage",
            params: { school_id: item._id },
          });
          break;
      }
    },

    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    getTotalPercentage() {
      return this.instalments.reduce(
        (total, instalment) => total + parseInt(instalment._percentage),
        0
      );
    },
    addInstalment() {
      if (!this.currentInstalment) return;

      this.instalments.push({
        _name: this.currentInstalment._name,
        _percentage: this.currentInstalment._percentage,
        _deadline: this.currentInstalment._deadline,
      });

      this.currentInstalment = {
        _name: "",
        _percentage: "",
        _deadline: "",
      };
    },
    async initialize() {
      if (this.$store.getters.marchand) {
        this.getAllFees();
        this.getSchool();
      }
    },

    async getSchool() {
      const response = await client({
        method: "get",
        url: `/school-payments/schools/${this.$route.params.school_id}`,
      })
        .then((resp) => resp.data)
        .catch(() => {
          return {
            error: "true",
          };
        });
      if (!response.error) this.school = response;

      console.log(this.school);
    },
    async getAllFees() {
      this.loadings.classes = true;
      const response = await client({
        method: "get",
        url: `/school-payments/school-settings/school/${this.$route.params.school_id}`,
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.classes = false;
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.loadings.classes = false;
        console.log(response);

        this.classes = response._defaultInstalments;
        // this.instalments = JSON.parse(JSON.stringify(response._defaultInstalments))

        console.log(this.classes);
      }
    },

    async saveInstalments() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.instalments_saving = true;

        console.log(this.instalments, "********** installment data***");
        const response = await client({
          method: "PUT",
          url: `/school-payments/school-settings/school/${this.$route.params.school_id}`,
          data: {
            _instalments: this.instalments,
          },
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            console.log(resp.data);
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.instalments_saving = false;
        this.dialogCustomer = false;
        this.getAllFees();
        this.toast(response.type, response.message);
      }
    },

    toggleEditSchool(item) {
      this.dialogCustomer = true;
      this.editingCustomer = true;
      this.settingToSave = item;
      this.id = item._id;
      console.log(this.id);
    },
    editCategoryItemAction(item, index) {
      switch (index) {
        case 0:
          this.toggleEdtiCategory(item);
          break;
        case 1:
          this.toggleDeleteCategory(item);
          break;
      }
    },

    toggleDeleteFee(item) {
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("delete_warning"),
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
        preConfirm: async () => {
          Swal.showLoading();
          try {
            const response = await client({
              method: "delete",
              url: `/school-payments/fees/${item._id}`,
            });
            Swal.hideLoading();
            Swal.fire({
              icon: "success",
              text: "Suppression réussi",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            console.log(response);
            await this.getAllFees();
            return response.data;
          } catch (error) {
            Swal.hideLoading();
            Swal.fire({
              icon: "error",
              text: "Erreur lors de la suppression",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            return { error: "true" };
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          console.log("finish with modal");
          this.getAllFees();
        }
      });
      console.log("finish with modal 2");
    },
    goToUserDetails(id) {
      let url = "/users/" + id;
      this.$router.push(url);
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    deleteItemConfirm() {},
    selectCategoryCustomerIcon(icon) {
      this.category._icon = icon.className;
    },

    getClass(item) {
      return `fa fa-2xl fa-${item._icon}`;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
  created() {
    this.checkisDashboard();
    this.initialize();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style scoped>
.circular--square {
  border-radius: 50%;
}

.circular--square {
  border-radius: 50% 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
}
svg:not(:host).svg-inline--fa,
svg:not(:root).svg-inline--fa {
  font-size: 20px;
}
</style>
